import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { ICatalogSearchSuggestionDTO } from '../models/catalog.models';
import { GlueConfigurationService } from './glue-configuration.service';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class SearchService {
  private readonly glueConfiguration: GlueConfigurationService = inject(GlueConfigurationService);
  private readonly http: HttpClient = inject(HttpClient);
  
  glueUrl: string = this.glueConfiguration.getEndpointUrl();

  getSuggestions(query: string = ''): Observable<ICatalogSearchSuggestionDTO> {
    const catalogSearchSuggestionUrl: string = this.glueUrl + '/catalog-search-suggestions?q=' + query;
    return this.http.get<ICatalogSearchSuggestionDTO>(catalogSearchSuggestionUrl)
      .pipe(
        catchError(error => throwError(() => error)),
      );
  }
}
